export default (backgroundColors: string[]): string => {
  if (backgroundColors.length === 1) {
    return backgroundColors[0];
  }

  return `linear-gradient(${backgroundColors.join(', ')})`;
};
